import { useEffect } from "react"
import {
  matchPath,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom"
import { get } from "lodash"
import { useGeoLocation } from "providers/geolocation"

export const MapIndex = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { userLocation } = useGeoLocation()

  useEffect(() => {
    // If the user enters `/maps`, navigate to the ordinal with the user's location; otherwise, navigate to the ground floor (ordinal 0) and use `replace` to prevent returning to `/maps`.
    const isQuickStartMapPath = matchPath("/maps", location.pathname)
    if (isQuickStartMapPath) {
      const initialOrdinal = get(userLocation, "properties.ordinal", 0)
      navigate(`/maps/ordinal/${initialOrdinal}?${searchParams.toString()}`, {
        replace: true,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, searchParams])

  return null
}
